/* Scoped department panels; no changes to the header/mobile navigation. */
(function () {
  'use strict';
  function init(root) {
    root.querySelectorAll('[data-serlex-context-nav]').forEach(function (panel) {
      if (panel.dataset.ready) return;
      panel.dataset.ready = 'true';
      panel.open = !window.matchMedia('(max-width: 989px)').matches;
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
